import styled from "@emotion/styled";
import { motion } from "@smartsheet/design-tokens";
import { withFocusToggleClassName } from "../../../util/withFocusClassName";
import { TextInputRootBox } from "../../textinput/styled/TextInputRootBox";
import { TextInputRootBoxProps, formInputTheme } from "../../textinput/styled/formInputTheme";
import { GROW_WRAPPER_CLASS } from "../constants";

// This is used to derive the fact that a 4 line textarea with
// box-sizing: border-box is exactly 94px high, so we can avoid
// magic numbers.
export const LINE_HEIGHT_PX = 18;

interface StyledTextAreaRootProps extends Omit<TextInputRootBoxProps, "variant"> {
    hasContentAfter: boolean;
    children?: React.ReactNode;
}

export const StyledTextAreaRoot = withFocusToggleClassName(styled(TextInputRootBox)<StyledTextAreaRootProps>`
    justify-content: space-between;
    height: auto;
    position: relative;
    padding: 0px;
    width: 100%;
    align-items: flex-start;
    padding-right: var(--sds--textarea--wrapper--padding-right, 4px);
    padding-top: var(--sds--textarea--wrapper--padding-top, 0px);
    padding-left: var(--sds--textarea--wrapper--padding-left, 0px);
    padding-bottom: var(--sds--textarea--wrapper--padding-bottom, 0px);
    transition: background-color 100ms ${motion.easing.default};
    color: ${({ themeMode, isDisabled }) =>
        isDisabled ? formInputTheme.textColor.readonly(themeMode) : formInputTheme.textColor.rest(themeMode)};

    textarea,
    div.${GROW_WRAPPER_CLASS} {
        font-size: ${({ themeMode }) => formInputTheme.fontSize.box(themeMode)};
        font-weight: ${({ themeMode }) => formInputTheme.fontWeight(themeMode)};
        line-height: ${LINE_HEIGHT_PX}px;
        font-family: inherit;
        border: none;
        grid-area: 1 / 1 / -1 / -1;
        white-space: pre-wrap;
        width: 100%;
        word-break: break-word;
        font: inherit;
        // necessary for firefox bug that adds 1px margin top/bottom, hiding the bottom border
        margin: 0;
        overflow-y: auto;
        box-sizing: border-box;
        border-radius: ${({ themeMode }) => formInputTheme.borderRadius(themeMode)};
        &:focus {
            outline: none;
        }
        ::-webkit-scrollbar-track {
            margin-top: 4px;
            margin-bottom: 4px;
        }
    }
`);
